import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';

export const unimportedTransactionsTableHeaders = () => {
    const baseHeaders = [
        {
            id: 'date',
            label: 'Date',
            sort: false,
        },
        {
            id: 'description',
            label: 'Description',
            sort: false,
        },
        {
            id: 'amount',
            label: 'Amount',
            sort: false,
            render: (row) => `${row.currency_code} ${row.amount}`,
        },
        {
            id: 'source',
            label: 'Source',
            sort: false,
            render: (row) => (
                <Tooltip title={row.source} placement="top">
                    <InfoIcon
                        sx={{
                            color: (theme) =>
                                theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.65)' : 'auto',
                        }}
                        fontSize="small"
                    />
                </Tooltip>
            ),
        },
    ];

    return [...baseHeaders];
};
